import BreadcrumbLink from '@/shared/ui/components/BreadcrumbLink';
import type { RoutePathDefinition } from '../../types';

export const careManagementRoutes: RoutePathDefinition[] = [
  {
    path: 'patients',
    lazy: () => import('@/pages/care-management/ui/patients').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Patients</BreadcrumbLink> }
  },
  {
    path: 'dashboard',
    lazy: () => import('@/pages/care-management/ui/dashboard').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Dashboard</BreadcrumbLink> }
  },
  {
    path: 'workqueue',
    lazy: () => import('@/pages/care-management/ui/Workqueue').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>Workqueue</BreadcrumbLink> }
  }
];
